import React, { useEffect, useMemo } from "react";
import { FlyerDetailPageFormProps } from "../../../../components/flyer-detail-page-form/flyer-detail-page-form.props";
import { FlyerDetailPageFormPositionView } from "../flyer-detail-page-form-position-view/flyer-detail-page-form-position-view.component";
import { useSelector } from "react-redux";
import * as store from "../../store/flyer-detail-page-form-position.store";
import { findLanguageCopyIndex } from "../../../../../../../../types/flyer-detail-data/flyer-detail-page-position/flyer-detail-page-position.functions";
import { SpinnerLoader } from "../../../../../../../../../../components/loaders";

export const FlyerDetailPageFormPosition = (props: FlyerDetailPageFormProps) => {
  const pagePosition = useSelector(store.getPosition);
  const isLoading = useSelector(store.isLoading);

  useEffect(() => {
    const pagePositionUninitialized = () => pagePosition === null && Boolean(props.pagePositionId);
    const pagePositionIdChanged = () => pagePosition && pagePosition.id !== props.pagePositionId;

    if (pagePositionUninitialized() || pagePositionIdChanged()) {
      store.fetchPosition(props.pagePositionId!);
    }
  }, [pagePosition, props.pagePositionId]);

  const languageIndex: number = useMemo(
    () => findLanguageCopyIndex(pagePosition, props.selectedLanguage),
    [pagePosition, props.selectedLanguage]
  );

  const hasContent = () => Boolean(pagePosition) && languageIndex >= 0;

  if (!props.permissions) {
    return null;
  }

  return (
    <>
      <SpinnerLoader showIf={isLoading} />
      <FlyerDetailPageFormPositionView
        flyerEndDatePassed={props.flyerEndDatePassed}
        showIf={hasContent() && !isLoading}
        languageIndex={languageIndex}
        pageId={props.pageId}
        position={pagePosition!}
        permissions={props.permissions}
        selectedLanguage={props.selectedLanguage}
        onSelectLanguage={props.onSelectLanguage}
        onSave={store.save}
      />
    </>
  );
};
